export const FETCH_ALL_ARTIST_REQUEST = "FETCH_ALL_ARTIST_REQUEST";
export const FETCH_ALL_ARTIST_SUCCESS = "FETCH_ALL_ARTIST_SUCCESS";
export const FETCH_ALL_ARTIST_FAILURE = "FETCH_ALL_ARTIST_FAILURE";

export const FETCH_ARTIST_DROPDOWN_REQUEST = "FETCH_ARTIST_DROPDOWN_REQUEST";
export const FETCH_ARTIST_DROPDOWN_SUCCESS = "FETCH_ARTIST_DROPDOWN_SUCCESS";
export const FETCH_ARTIST_DROPDOWN_FAILURE = "FETCH_ARTIST_DROPDOWN_FAILURE";
